import type { FunctionComponent } from "react";
import type { GetProps } from "tamagui";
import type { IconProps } from "@tamagui/helpers-icon";
import { Paragraph, type ParagraphProps, Separator, styled, XStack, YStack, type YStackProps } from "@medbillai/ui";
import { BackgroundRadialGrantedGradient } from "../../../components/BackgroundRadialGrantedGradient";
export const Divider = styled(Separator, {
  borderBottomColor: "$backgroundTertiary",
  borderBottomWidth: 6,
  width: "100%"
});
const Gradient = (props: GetProps<typeof BackgroundRadialGrantedGradient>) => <BackgroundRadialGrantedGradient
// Without this, the gradient gets cut off on mobile. We'd considered
// pushing this down into that component, but it's used so many places
// that it's easier to just do it here.
width={undefined} height={undefined} fullscreen {...props} data-sentry-element="BackgroundRadialGrantedGradient" data-sentry-component="Gradient" data-sentry-source-file="WidgetWrapper.tsx" />;
export function WidgetWrapper({
  title,
  titleIcon: TitleIcon,
  showGradient,
  children,
  wrapperProps,
  titleProps,
  removeDivider = false
}: {
  title: string;
  titleIcon?: FunctionComponent<IconProps>;
  showGradient?: "full" | "inner";
  children: React.ReactNode;
  wrapperProps?: YStackProps;
  titleProps?: ParagraphProps;
  removeDivider?: boolean;
}) {
  return <>
      <YStack py="$6" px="$4" {...wrapperProps} data-sentry-element="YStack" data-sentry-source-file="WidgetWrapper.tsx">
        {showGradient === "full" ? <Gradient /> : null}
        {TitleIcon ? <XStack alignItems="center" gap="$1" pb="$4">
            <TitleIcon size="$1" color="$navy12" />
            <Paragraph {...titleProps}>{title}</Paragraph>
          </XStack> : <Paragraph pb="$4" {...titleProps}>
            {title}
          </Paragraph>}
        {showGradient === "inner" ? <YStack padding="$7">
            <Gradient borderRadius="$4" />
            {children}
          </YStack> : children}
      </YStack>
      {removeDivider ? null : <Divider />}
    </>;
}